<script setup>
import { ref } from 'vue'
import { DocumentDownloadIcon } from "@heroicons/vue/outline"

const props = defineProps({
	invoiceId: {
		type: String,
		required: true,
	},
})

const downloadButton = ref(null)

function downloadPDF(){
    downloadButton.value.waitFor(
        axios.get(`/api/invoices/${props.invoiceId}/pdf`, {
			responseType: 'blob'
		})
        .then(response => {
			console.log(response);
			// the response is a blob file response from laravel
			// so we need to create a new blob file from it
			const file = new Blob([response.data], {type: 'application/pdf'})

			// create a new url from the blob
			const fileURL = URL.createObjectURL(file)

			// create a new anchor tag
			const link = document.createElement('a')
			link.href = fileURL
			link.download = props.invoiceId + '.pdf'
			document.body.appendChild(link)

			// click on the anchor tag
			link.dispatchEvent(
				new MouseEvent('click', {
					bubbles: true,
					cancelable: true,
					view: window
				})
			)
			
			// remove the anchor tag
			document.body.removeChild(link)
        })
    )
}

</script>

<template>
	<PromiseButton 
		ref="downloadButton"
		@click.stop.prevent="downloadPDF" 
		class="w-24"
		variant="outline"
		color="blue"
		size="sm"
		data-testid="download-pdf-btn"
		:data-test-xero-id="invoiceId"
	>
		<DocumentDownloadIcon class="w-4 mr-2" /> PDF
	</PromiseButton>
</template>